import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BarcodeScanner } from '@awesome-cordova-plugins/barcode-scanner/ngx';
import { AlertController, LoadingController } from '@ionic/angular';
import { take } from 'rxjs/operators';
import { DriverProfileService } from 'src/app/services/driver-profile/driver-profile.service';
import { UserProfileService } from 'src/app/services/user-profile/user-profile.service';

@Component({
  selector: 'app-qr-call-user',
  templateUrl: './qr-call-user.page.html',
  styleUrls: ['./qr-call-user.page.scss'],
})
export class QrCallUserPage implements OnInit {
  driverID;
  phoneNo;
  loading;
  callerDocId;

  topUpForm: FormGroup;
  showForm = false;

  updateForm: FormGroup;
  showUpdateForm = false;

  walletValue: number;

  constructor(
    private alertController: AlertController,
    private loadingController: LoadingController,
    private userProfile: UserProfileService,
    private driverService: DriverProfileService,
    private auth: AngularFireAuth,
    private formBuilder: FormBuilder,
    private barcodeScanner: BarcodeScanner,
    private router: Router
  ) {}

  ngOnInit() {
    this.auth.authState.pipe(take(1)).subscribe((user) => {
      if (user) {
        this.driverID = user.uid;
      }
    });
  }

  scanQR(updateUser: boolean) {
    this.barcodeScanner
      .scan()
      .then((barcodeData) => {
        if (!barcodeData.cancelled && barcodeData.text) {
          this.phoneNo = barcodeData.text;
          this.checkUser(this.phoneNo, updateUser);
        } else {
          this.alert('Scanning Cancelled!');
        }
      })
      .catch((err) => {
        this.alert(err);
      });
  }

  checkUser(phoneNo: string, updateUser: boolean) {
    this.presetLoading();
    this.userProfile
      .getCallerProfile(phoneNo)
      .pipe(take(1))
      .subscribe((res) => {
        this.dismissLoading();
        if (res.docs.length > 0) {
          this.callerDocId = res.docs[0].id;
          const data = res.docs[0].data() as {
            customerName: string;
            customerCellphone: string;
            wallet: number;
          };

          if (updateUser === true) {
            this.showUpdateForm = true;
            this.updateForm = this.formBuilder.group({
              fullName: [data.customerName, [Validators.required]],
            });
          } else {
            if (data.wallet) {
              this.walletValue = data.wallet;
            } else {
              this.walletValue = 0;
            }
            this.confirmUser(data.customerName, data.customerCellphone);
          }
        } else {
          alert('Invalid User');
        }
      });
  }

  async confirmUser(name, phone) {
    const body = `Is this ${name}, ${phone}`;
    const alert = await this.alertController.create({
      header: 'Confirm User',
      message: body,
      buttons: [
        {
          text: 'No',
          handler: () => {
            this.showForm = false;
          },
        },
        {
          text: 'Yes',
          handler: () => {
            this.showForm = true;
            this.createForm();
          },
        },
      ],
    });

    await alert.present();
  }

  createForm() {
    this.topUpForm = this.formBuilder.group({
      rands: ['', [Validators.required, Validators.min(45)]],
      paymentMethod: ['', Validators.required],
    });
  }

  topUpWallet() {
    this.presetLoading();
    const { rands, paymentMethod } = this.topUpForm.value;
    if (this.phoneNo && this.driverID) {
      this.driverService
        .topUpCallerWalletQR(
          this.callerDocId,
          this.phoneNo,
          this.walletValue,
          rands,
          this.driverID,
          paymentMethod
        )
        .then(() => {
          this.dismissLoading();
          this.alert('Wallet Topped Up');
          this.showForm = false;
          this.walletValue = 0;
          this.topUpForm.reset();
          this.router.navigate(['/qr-top-up']);
        })
        .catch((e) => {
          this.dismissLoading();
          this.alert('Error ' + e);
        });
    }
  }

  async alert(msg) {
    const alert = await this.alertController.create({
      message: msg,
      buttons: ['OK'],
    });

    await alert.present();
  }

  async presetLoading() {
    this.loading = await this.loadingController.create({
      message: 'Loading ...',
    });

    await this.loading.present();
  }

  async dismissLoading() {
    this.loading.dismiss();
  }

  updateCaller() {
    const { fullName } = this.updateForm.value;

    this.driverService
      .updateCallerNames(this.callerDocId, fullName)
      .then(() => {
        this.showUpdateForm = false;
        this.updateForm.reset();
        this.alert('Caller Details Updated!');
      })
      .catch((e) => {
        this.alert(e.message);
      });
  }
}
